import { render } from "./detail-grid-history.vue?vue&type=template&id=713644ba&ts=true"
import script from "./detail-grid-history.vue?vue&type=script&lang=ts"
export * from "./detail-grid-history.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__